import React from 'react';

const card = {
  background: '#fff',
  borderRadius: 10,
  padding: 24,
  marginBottom: 16,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
};

export default function SummaryTab({
  grandMat, grandLabor, qaHrs, shipHrs, qaShipLabor,
  grandHrs, laborRate, ohPct,
  totalFreight, miles, freightMode,
  grandCost, grandSellNoFrt, grandGP, gpPctGrand,
  totalMktWithEF, totalBktMat, totalInfraMat,
  totalBktLabor, totalInfraLabor,
  C, fmt, pct,
}) {
  const summaryCards = [
    { label: 'Total Cost', value: fmt(grandCost), color: C.blue || '#2563eb' },
    { label: 'Sell Price', value: fmt(grandSellNoFrt), color: C.green || '#16a34a' },
    { label: 'Gross Profit', value: fmt(grandGP), color: grandGP >= 0 ? (C.green || '#16a34a') : (C.red || '#ef4444') },
    { label: 'GP %', value: pct(gpPctGrand), color: gpPctGrand >= 0.2 ? (C.green || '#16a34a') : (C.orange || '#f59e0b') },
  ];

  const matTotal = grandMat;
  const labTotal = grandLabor;
  const total = matTotal + labTotal || 1;
  const matPct = matTotal / total;
  const labPct = labTotal / total;

  return (
    <div style={{ maxWidth: 900, margin: '0 auto' }}>
      {/* Executive Summary Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 16 }}>
        {summaryCards.map((c) => (
          <div
            key={c.label}
            style={{
              ...card,
              marginBottom: 0,
              textAlign: 'center',
              borderTop: `3px solid ${c.color}`,
            }}
          >
            <div style={{ fontSize: 11, color: '#64748b', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>
              {c.label}
            </div>
            <div style={{ fontSize: 22, fontWeight: 700, color: c.color }}>{c.value}</div>
          </div>
        ))}
      </div>

      {/* Material vs Labor Breakdown */}
      <div style={card}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12 }}>Material vs Labor Breakdown</div>

        <div style={{ display: 'flex', borderRadius: 6, overflow: 'hidden', height: 28, marginBottom: 10 }}>
          <div
            style={{
              width: `${(matPct * 100).toFixed(1)}%`,
              background: C.blue || '#2563eb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontSize: 11,
              fontWeight: 600,
              minWidth: 40,
            }}
          >
            {(matPct * 100).toFixed(0)}%
          </div>
          <div
            style={{
              width: `${(labPct * 100).toFixed(1)}%`,
              background: C.orange || '#f59e0b',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontSize: 11,
              fontWeight: 600,
              minWidth: 40,
            }}
          >
            {(labPct * 100).toFixed(0)}%
          </div>
        </div>

        <div style={{ display: 'flex', gap: 24, fontSize: 12 }}>
          <div>
            <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: 2, background: C.blue || '#2563eb', marginRight: 6 }} />
            Material: {fmt(matTotal)}
          </div>
          <div>
            <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: 2, background: C.orange || '#f59e0b', marginRight: 6 }} />
            Labor: {fmt(labTotal)}
          </div>
        </div>

        <div style={{ marginTop: 14, fontSize: 12, color: '#64748b' }}>
          <div>Bucket Material: {fmt(totalBktMat)} &nbsp;|&nbsp; Infra Material: {fmt(totalInfraMat)}</div>
          <div>Bucket Labor: {fmt(totalBktLabor)} &nbsp;|&nbsp; Infra Labor: {fmt(totalInfraLabor)}</div>
        </div>
      </div>

      {/* Market Comparison */}
      {totalMktWithEF > 0 && (
        <div style={card}>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10 }}>Market Comparison</div>
          <div style={{ fontSize: 13 }}>
            Market benchmark: <strong>{fmt(totalMktWithEF)}</strong>
            {grandSellNoFrt <= totalMktWithEF ? (
              <span style={{ marginLeft: 10, color: C.green || '#16a34a', fontWeight: 600 }}>
                Below market ({fmt(totalMktWithEF - grandSellNoFrt)} under)
              </span>
            ) : (
              <span style={{ marginLeft: 10, color: C.red || '#ef4444', fontWeight: 600 }}>
                Above market ({fmt(grandSellNoFrt - totalMktWithEF)} over)
              </span>
            )}
          </div>
        </div>
      )}

      {/* QA & Shipping */}
      <div style={card}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10 }}>QA & Shipping Hours</div>
        <div style={{ display: 'flex', gap: 32, fontSize: 13 }}>
          <div>QA / Test: <strong>{qaHrs.toFixed(1)} hrs</strong></div>
          <div>Shipping: <strong>{shipHrs.toFixed(1)} hrs</strong></div>
          <div>Labor Cost: <strong>{fmt(qaShipLabor)}</strong></div>
        </div>
      </div>

      {/* Freight */}
      <div style={card}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10 }}>Freight Summary</div>
        <div style={{ fontSize: 13 }}>
          {freightMode} &nbsp;|&nbsp; {miles} miles &nbsp;|&nbsp; <strong>{fmt(totalFreight)}</strong>
        </div>
      </div>
    </div>
  );
}
